export default {
  path: '/2019ConsumerGoods',
  name: '2019ConsumerGoods',
  component: () => import('./home.vue'),
  base: '/2019ConsumerGoods/',
  redirect: '/2019ConsumerGoods/List',
  meta: {
    title: '““为高质量点赞”--重庆市2019年度消费品（服务）评价展示活动',
  },
  children: [
    {
      path: 'Rule',
      component: () => import('./Rule.vue'),
      name: 'HandcraftPaperRule',
      meta: {
        title: '“为高质量点赞”--重庆市2019年度消费品（服务）评价展示活动',
      },
    },

    {
      path: 'Rule2',
      component: () => import('./Rule2.vue'),
      name: 'HandcraftPaperRule',
      meta: {
        title: '“为高质量点赞”--重庆市2019年度消费品（服务）评价展示活动',
      },
    },

    {
      path: 'List',
      component: () => import('./List.vue'),
      name: 'HandcraftPaperList',
      meta: {
        title: '“为高质量点赞”--重庆市2019年度消费品（服务）评价展示活动',
      },
    },

    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: 'HandcraftPaperDetail',
      meta: {
        title: '“为高质量点赞”--重庆市2019年度消费品（服务）评价展示活动',
      },
    },
  ],
};
